module.exports = __webpack_public_path__ + "static/img/huaishuImg5.f216aaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/huaishuImg5.png
// module id = 2jEP
// module chunks = 0